import { createContext, useContext } from "react";

import type { PublicOffer } from "../../features/landing/types";
import { DEFAULT_LANG, type MarketingLang } from "../content/routes";

export interface MarketingContextValue {
  lang: MarketingLang;
  offer?: PublicOffer;
  offerLoading: boolean;
  founderEnabled: boolean;
}

export const MarketingContext = createContext<MarketingContextValue>({
  lang: DEFAULT_LANG,
  offerLoading: true,
  founderEnabled: false,
});

export function useMarketingContext() {
  return useContext(MarketingContext);
}
